/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LnrpLoginResponseDto interface.
 */
export function instanceOfLnrpLoginResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function LnrpLoginResponseDtoFromJSON(json) {
    return LnrpLoginResponseDtoFromJSONTyped(json, false);
}
export function LnrpLoginResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
export function LnrpLoginResponseDtoToJSON(json) {
    return LnrpLoginResponseDtoToJSONTyped(json, false);
}
export function LnrpLoginResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}
